<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" text="Xác nhận" position="top" v-if="rowData.status !== 4 && !rowData.presentStatus">
                <feather-icon icon="CheckIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 text-success cursor-pointer" @click="confirm"/>
            </vx-tooltip>
            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="editRecord"/>
            </vx-tooltip>
        </div>

        <vs-popup class="holamundo"  title="" :active.sync="popupDetailsBooking" v-if="popupDetailsBooking" id="popup-details-booking">
            <BookingInfo :bookingId="rowData.id" />
        </vs-popup>
    </div>
</template>

<script>
import BookingInfo from "@/views/user-pages/crm-module/booking/BookingInfo";
import { mapState } from 'vuex';


export default {
    name: 'CellRendererActions',
    props: {
        rowData: {
            type: Object,
            required: true,
        },
    },
    components: {
        BookingInfo
    },
    data() {
        return {
            popupDetailsBooking: false
        }
    },
    methods: {
        editRecord() {
            // this.$router.push(`/user/booking-schedule-info?beautyBookingId=${this.params.data.id}`).catch(() => {
            // })
            this.popupDetailsBooking = true
        },
        confirm() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận cập nhật`,
                text: `Xác nhận khách hàng đã tới phòng khám, hồ sơ sẽ được chuyển sang khách hàng tới phòng khám!`,
                accept: this.confirmCustomerArrived,
                acceptText: "Xác nhận",
                cancelText: "Huỷ"
            })
        },

        confirmCustomerArrived() {
            let payload = this.rowData;
            payload.beautyBookingDetails[0].organizationBranchId =  payload.organizationBranchId
            payload.beautyBookingDetails[0].beautyBookingId =  payload.beautyBookingDetails[0].beautyBooking.id
            payload.beautyBookingDetails[0].beautyServicePackageId =  payload.beautyBookingDetails[0].beautyServicePackage.id
            payload.beautyBookingDetails[0].beautyPackageComboId =  null
            payload.beautyBookingDetails[0].performerId =  payload.performerId
            payload.beautyBookingDetails[0].presentStatus = 1;
            this.$vs.loading();
            this.$crm.post(`beauty-booking/update/${this.rowData.id}`, payload).then(() => {
                this.$vs.notify({
                    text: `Cập nhật khách hàng đến thành công!'`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        }
    },
    watch: {
        '$store.state.isBookingPopupOpen'(val) {
            this.popupDetailsBooking = val;
        }
    },
    // mounted() {
    //     this.popupDetailsBooking = this.isBookingPopupOpen;
    // }
    // computed: {
    //     ...mapState(['isBookingPopupOpen'])
    // },
    // watch: {
    //   '$store.state.isUpdatePostsInfo'(val) {
    //     console.log(val);
    //     if (val) {
    //       this.popupDetailsBooking = false;
    //       this.$store.commit('UPDATE_POSTS_INFO', false);
    //     }
    //   },
    // }
}
</script>

<style lang="scss">
.popup_cancel .vs-popup--header {
    background: rgba(var(--vs-danger));
}

.popup_confirm .vs-popup--header {
    background: rgba(var(--vs-primary));
}

#popup-details-booking {
    .vs-popup {
        width: 80%;
    }
}

</style>
